export default __webpack_public_path__ + "static/media/sbi.cb64a12c.png";